import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import Avatar from 'react-avatar';
import useGlobal from "store";
import { Link } from "react-router-dom";


const UserInfo = (props) => {

    const [state, authActions] = useGlobal(
        state => state,
        actions => actions.authActions
    );

    const logout = () => {
      console.log('logout');
      authActions.logout();
    }

    const [openAvatar, setOpenAvatar] = useState(props.openAvatar);

    useEffect(() => {
        console.log('user state', state.user);
    }, [state.user]);

    return (
        <div className="user">
              <div className="photo">
                  {state.user && state.user.first_name ?
                    <Avatar name={state.user.first_name + " " + state.user.last_name} color={'#FFC7AD'} size={34} />
                  : <></> }
              </div>
              <div className="info">
                <a
                  href="#top"
                  data-toggle="collapse"
                  aria-expanded={openAvatar}
                  onClick={() => setOpenAvatar(!openAvatar) }
                >
                    { state.user ? 
                        <span>
                            {state.user.first_name} {state.user.last_name}
                            <b className="caret" />
                    </span> : <></> }
                </a>
                <Collapse isOpen={openAvatar}>
                  <ul className="nav">
                    <li>
                      <Link to="/admin/profile">
                        <span className="sidebar-mini-icon">MP</span>
                        <span className="sidebar-normal">My Profile</span>
                      </Link>
                    </li>
                    <li>
                      <a href="#logout" onClick={() => logout()}>
                        <span className="sidebar-mini-icon">L</span>
                        <span className="sidebar-normal">Logout</span>
                      </a>
                    </li>
                  </ul>
                </Collapse>
              </div>
            </div>
    );
}


export default UserInfo;